import Modal from 'shared/Modal';
import { getAlert } from 'modules/alert';
import { useSelector } from 'react-redux';
import { Button, Box, Text } from 'theme-ui';
import { useTranslator } from '@picsart/rc/services/localization';

export const ErrorBoundaryModal = () => {
  const alert = useSelector(getAlert);
  const translator = useTranslator();

  return (
    <Modal opened={!!alert?.isModal} color="transparent" title={translator('Error')}>
      <Box>
        <Text sx={{ mb: 6 }}>{translator(alert?.message)}</Text>
        <Button variant="primary" onClick={() => window.location.reload()} data-test="reload">
          {translator('Reload')}
        </Button>
      </Box>
    </Modal>
  );
};
